import React from 'react';
import PropTypes from 'prop-types';
import { tracksColors } from "../../../config/styles";
import { TRACK_STATUS_CLOSED, TRACK_STATUS_OPEN } from "../../../config/constants";
import classnames from 'classnames';

const LegendBlockItemsList = ({ tracks, onClickOnTrack, isClosed }) => (
   <ul
      className={classnames("legend-tracks-list", {
         "legend-tracks-list--closed": isClosed,
         "legend-tracks-list--open": !isClosed
      })}
   >
      {Object.keys(tracks).map(trackId => {
         const track = tracks[trackId];

         return (
            <li key={track.info.name}
                style={{ color: tracksColors[isClosed ? TRACK_STATUS_CLOSED : TRACK_STATUS_OPEN] }}
                data-bordercolor={tracksColors[isClosed ? TRACK_STATUS_CLOSED : TRACK_STATUS_OPEN]}
                onClick={() => onClickOnTrack(trackId)}
            >
               {track.info.name}
            </li>
         )
      })}
   </ul>
);

LegendBlockItemsList.propTypes = {
   tracks: PropTypes.object,
   onClickOnTrack: PropTypes.func,
   isClosed: PropTypes.bool
};

export default LegendBlockItemsList;
